import React from "react";
import { useFela } from "react-fela";

import { useTheme } from "@/hooks/useTheme";

type IProps = { text: string } & Omit<
  JSX.IntrinsicElements["label"],
  "children"
>;

export const Label: React.FC<IProps> = ({ text, htmlFor, ...rest }) => {
  const { colors } = useTheme();
  const { css } = useFela();

  return (
    <label
      className={css({
        color: colors.DARK_GREY,
        fontWeight: 700,
        fontSize: 16,
        lineHeight: "24px",
        marginBottom: 12,
      })}
      htmlFor={htmlFor}
      {...rest}
    >
      {text}
    </label>
  );
};
